/* Tysk katalog for locale-bank-misc-no.js (del 2 av 3).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'km.privateDrivingHelp': 'Die private Nutzung ist im Fahrtenbuch dokumentiert, ergibt aber keinen Abzug.',
  'km.filterType': 'Typ',
  'km.tryOtherSearch': 'Versuche eine andere Suche oder setze den Filter zurück.',
  'km.distance': 'Strecke',
  'km.stops': 'Stopps',
  'km.returnYes': 'Ja ({km} km pro Strecke)',
  'km.returnNo': 'Nein',
  'km.status': 'Status',
  'km.statusLogged': 'Protokolliert',
  'km.statusPosted': 'Gebucht',
  'km.route': 'Route',
  'km.amount': 'Betrag',
  'km.deleteTripBody': 'Möchtest du diese Fahrt{route} wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
  'km.speedUnit': 'km/h',
  'km.gps.unavailable': 'GPS ist in diesem Browser nicht verfügbar.',
  'km.gps.denied': 'Der GPS-Zugriff wurde verweigert oder konnte nicht gestartet werden.',
  'km.gps.active': 'GPS aktiv',
  'km.gps.inactive': 'GPS ist nicht aktiv',
  'km.gps.stop': 'Fahrt beenden',
  'km.gps.start': 'Fahrt starten',
  'km.gps.done': 'Fahrt abgeschlossen',
  'km.gps.tracking': 'Deine Position wird verfolgt.',
  'km.gps.doneHint': '{km} km erfasst. Verwende die Strecke im Formular unten.',
  'km.gps.startHint': 'Starte die Fahrt, um die GPS-Verfolgung zu aktivieren.',
  'km.toast.editTrip': 'Fahrt bearbeiten - ändern und erneut speichern',
  'km.toast.openedNotFound': 'Fahrtenbuch geöffnet. Die genaue Fahrt zum automatischen Bearbeiten wurde nicht gefunden.',
  'km.toast.fillFromTo': 'Fülle zuerst mindestens die Start- und Zieladresse aus.',
  'km.toast.calcUnavailable': 'Die automatische km-Berechnung ist noch nicht verfügbar.',
  'km.toast.distanceFailed': 'Die Entfernung konnte nicht berechnet werden.',
  'km.toast.kmCalculated': 'Kilometer automatisch berechnet',
  'km.toast.calcFailed': 'Die Kilometer konnten nicht automatisch berechnet werden.',
  'km.toast.fillPrivate': 'Fülle Datum, Start, Ziel und Kilometer aus, bevor du die Privatfahrt speicherst.',
  'km.toast.fillBusiness': 'Fülle Datum, Start, Ziel, Zweck und Kilometer aus, bevor du speicherst.',
  'km.toast.updated': 'Die Fahrt wurde aktualisiert',
  'km.toast.saved': 'Die Fahrt wurde gespeichert',
  'km.toast.deleted': 'Fahrt gelöscht',
  'bank.filter.all': 'Alle',
  'bank.filter.processing': 'Zu bearbeiten',
  'bank.filter.suggestion': 'Vorschlag bereit',
  'bank.filter.control': 'Prüfung nötig',
  'bank.filter.missing': 'Beleg fehlt',
  'bank.filter.deviation': 'Mögliche Abweichung',
  'bank.filter.done': 'Erledigt',
  'bank.typeGroup.sales': 'Verkauf',
  'bank.typeGroup.purchase': 'Einkauf',
  'bank.typeGroup.other': 'Sonstiges',
  'bank.typeGroup.tax': 'Steuern und Abgaben',
  'bank.typeGroup.loan': 'Darlehen und Verbindlichkeiten',
  'bank.type.invoicePayment': 'Rechnungszahlung',
  'bank.type.otherSales': 'Sonstiger Verkauf',
  'bank.type.payOpenSupplier': 'Lieferantenrechnung: offene bezahlen',
  'bank.type.newSupplier': 'Lieferantenrechnung: neue erfassen',
  'bank.type.purchase': 'Normaler Einkauf',
  'bank.type.free': 'Freie Buchung',
  'bank.type.fee': 'Gebühr',
  'bank.type.rounding': 'Rundungsdifferenz',
  'bank.type.owner': 'Privatentnahme / -einlage',
  'bank.type.vat': 'MwSt.-Zahlung',
  'bank.type.payroll': 'Lohnsteuerabzug / AGA',
  'bank.type.tax': 'Steuerzahlung',
  'bank.type.loan': 'Darlehen / Verbindlichkeit',
  'bank.agaPart.withholding': 'Lohnsteuerabzug gegen 2600',
  'bank.agaPart.employer': 'Arbeitgeberabgabe gegen 2770',
  'bank.agaPart.both': 'Beides zusammen, aufgeteilt auf 2600 und 2770',
  'bank.vat.none': 'Keine MwSt.',
  'bank.vat.input': '{{code}} - Vorsteuer {{rate}} %',
  'bank.accountFallback': 'Konto {{code}}',
  'bank.countsAsZero': '{{note}} · zählt in der Abstimmung als 0,00 kr',
  'bank.csv.date': 'Datum',
  'bank.csv.description': 'Beschreibung',
  'bank.csv.note': 'Notiz',
  'bank.csv.amount': 'Betrag',
  'bank.csv.balance': 'Saldo',
  'bank.posted.amount': 'Gebucht {{amount}}',
  'bank.posted': 'Gebucht',
  'bank.posted.vatAmount': 'MwSt. {{amount}} ({{rate}} %)',
  'bank.posted.vatRate': 'MwSt. {{rate}} %',
  'bank.err.pickSupplierInvoice': 'Wähle die Lieferantenrechnung, auf die sich die Zahlung bezieht.',
  'bank.err.supplierPaymentMustBeOutgoing': 'Die Zahlung einer Lieferantenrechnung muss eine Auszahlung von der Bank sein.',
  'bank.err.supplierPaymentUnavailable': 'Das Bezahlen einer Lieferantenrechnung über die Bank ist noch nicht verfügbar.',
  'bank.deviation.intro': 'Diese Posten sind auf das Bankkonto gebucht, aber Plumme findet keine sichere Bankzeile, die sie erklärt.',
  'bank.deviation.none': 'Keine möglichen Abweichungen in diesem Zeitraum.',
  'bank.detail.date': 'Datum',
  'bank.detail.amount': 'Betrag',
  'bank.detail.status': 'Status',
  'bank.detail.postId': 'Posten-ID',
  'bank.detail.type': 'Typ',
  'bank.detail.period': 'Zeitraum',
  'bank.detail.noReceipt': 'Mit der Buchung ist kein Beleg verknüpft',
  'bank.detail.receiptPreviewable': 'Der Beleg kann hier direkt in der Vorschau angezeigt werden.',
  'bank.detail.noPreview': 'Es gibt keinen Beleg für eine Vorschau.',
  'bank.toast.postingCorrected': 'Die gebuchte Buchung wurde korrigiert',
  'bank.toast.postingVoided': 'Die Buchung wurde annulliert. Ein eventueller Beleg liegt wieder im Posteingang.',
  'bank.transition.review': 'Prüfe den Übergang aus der importierten Buchhaltung, bevor dieser Kontoauszug gebucht wird.',
  'bank.transition.fixOpening': '{{message}} Korrigiere den Anfangssaldo, bevor du buchst.',
  'bank.toast.voucherLinkedName': 'Beleg verknüpft: {{name}}',
  'bank.toast.noVoucherSuggestions': 'SuperPlumma hat keine Belegvorschläge zum Verknüpfen.',
  'bank.toast.oneVoucherLinked': 'Ein Beleg wurde verknüpft',
  'bank.toast.nVouchersLinked': '{{count}} Belege verknüpft',
  'bank.toast.linkSuggestedFailed': 'Die vorgeschlagenen Belege konnten nicht verknüpft werden.',
  'bank.toast.linkedToPosted': 'Die Bankzeile ist mit dem bereits gebuchten Posten verknüpft',
  'bank.toast.linkToPostedFailed': 'Die Bankzeile konnte nicht mit dem gebuchten Posten verknüpft werden.',
  'bank.toast.saveCustomerFirst': 'Speichere den Kunden, bevor die Zeile genehmigt wird.',
  'bank.toast.saveSupplierFirst': 'Speichere oder wähle den Lieferanten, bevor die Zeile genehmigt wird.',
  'bank.toast.reviewSuggestionFirst': 'Prüfe den Vorschlag in der Bankzeile, bevor du genehmigst.',
  'bank.toast.invoicePaymentDone': 'Die Rechnungszahlung ist gebucht und die Bankzeile erledigt',
  'bank.toast.supplierPaymentDone': 'Die Lieferantenrechnung ist bezahlt und die Bankzeile erledigt',
  'bank.toast.enterSupplierName': 'Gib den Lieferantennamen ein, bevor die Rechnung genehmigt wird.',
  'bank.toast.enterInvoiceNumber': 'Gib die Rechnungsnummer ein, bevor die Rechnung genehmigt wird.',
  'bank.toast.checkCostAccount': 'Prüfe das Kostenkonto, bevor die Rechnung genehmigt wird.',
  'bank.toast.supplierInvoiceDone': 'Die Lieferantenrechnung ist gebucht und die Bankzeile erledigt',
  'bank.toast.suggestionDone': 'Der Vorschlag ist gebucht und die Bankzeile erledigt',
  'bank.toast.alreadyDone': 'Die Bankzeile ist bereits gebucht und erledigt',
  'bank.toast.suggestionNotApproved': 'Der Vorschlag konnte nicht genehmigt werden.',
  'bank.toast.suggestionNeedsReview': 'Der Vorschlag muss vor der Genehmigung geprüft werden.',
  'bank.approve': 'Genehmigen',
  'bank.toast.pickUnprocessed': 'Wähle mindestens eine unbearbeitete Bankzeile.',
  'bank.toast.approveLineFailed': 'Die Bankzeile konnte nicht genehmigt werden.',
  'bank.toast.nLinesApproved': '{{count}} Zeilen genehmigt',
  'bank.toast.lineAdded': 'Bankzeile hinzugefügt',
  'bank.toast.lineLinkUnavailable': 'Das Verknüpfen von Bankzeilen ist noch nicht verfügbar.',
  'bank.toast.linkedToExistingPosted': 'Die Bankzeile ist mit einem bestehenden gebuchten Posten verknüpft',
  'bank.controlPosting.title': 'Gebuchter Bankposten',
  'bank.controlPosting.sub': 'Mögliche Abweichung: auf dem Bankkonto gebucht, aber nicht im Kontoauszug gefunden.',
  'bank.toast.openedAsDeviation': 'Die Bankzeile wurde als Abweichung geöffnet',
  'bank.toast.investmentMatchReopened': 'Die Bankzuordnung zur Investition wurde freigegeben',
  'bank.toast.balanceCorrectionUnavailable': 'Die Saldokorrektur ist noch nicht verfügbar.',
  'bank.toast.openingMustBeNumber': 'Der Anfangssaldo muss eine Zahl sein.',
  'bank.toast.openingUpdated': 'Anfangssaldo aktualisiert',
  'bank.toast.openingFromImport': 'Anfangssaldo aus dem Importübergang übernommen',
  'bank.toast.closingMustBeNumber': 'Der Endsaldo muss eine Zahl sein.',
  'bank.toast.closingUpdated': 'Endsaldo aktualisiert',
  'bank.toast.roundingMustBeNumber': 'Die Rundungsdifferenz muss eine Zahl sein.',
  'bank.toast.roundingCorrected': 'Rundungsdifferenz korrigiert',
  'bank.mark.posted': 'Gebucht',
  'bank.mark.alreadyPosted': 'Bereits gebucht',
  'bank.mark.approved': 'Genehmigt',
  'bank.mark.needsReview': 'Prüfung nötig',
  'bank.mark.deviation': 'Mögliche Abweichung',
  'bank.mark.suggestion': 'Vorschlag bereit',
  'bank.mark.private': 'Privat',
  'bank.mark.removed': 'Entfernt',
  'bank.mark.new': 'Nicht bearbeitet',
  'bank.toast.analysisUnavailable': 'Die SuperPlumma-Analyse ist noch nicht verfügbar.',
  'bank.toast.foundSuggestions': 'SuperPlumma hat {{count}} Vorschläge zur Prüfung gefunden',
  'bank.toast.noSafeSuggestions': 'SuperPlumma hat keine sicheren Vorschläge gefunden',
  'bank.toast.analysisFailed': 'SuperPlumma konnte die Bankzeilen nicht analysieren.',
  'bank.toast.alreadyArchived': 'Der Kontoauszug ist bereits abgestimmt und archiviert.',
  'bank.toast.reconciledArchived': 'Der Kontoauszug ist abgestimmt und archiviert.',
  'bank.toast.reopenFailed': 'Die Abstimmung konnte nicht wieder geöffnet werden.',
  'bank.matchMultiple': 'Mehrere zuordnen',
  'bank.transition.title': 'Übergang aus der importierten Buchhaltung prüfen',
  'bank.transition.changeAnchor': 'Ändere „Abgestimmt bis einschließlich“ und den Startsaldo in den Einstellungen, falls der Importanker falsch gesetzt wurde.',
  'bank.previousNotReconciled': 'Ein früherer Zeitraum ist nicht abgestimmt',
  'bank.correctViaPencil': 'Über das Stiftsymbol korrigieren',
  'bank.correctReadBalance': 'Ausgelesenen Saldo korrigieren',
  'bank.analysis.alreadyDone': 'Der Kontoauszug wurde bereits analysiert. Eine neue Analyse ist gesperrt, um unnötigen Token-Verbrauch zu vermeiden.',
  'bank.analysis.autoRunning': 'SuperPlumma analysiert den Kontoauszug automatisch.',
  'bank.analysis.analyzedShort': 'Von SuperPlumma analysiert',
  'bank.analysis.analyzingShort': 'SuperPlumma analysiert',
  'bank.archiveBlocked.chronological': 'Stimme zuerst {{name}} ab. Die Abstimmung muss chronologisch erfolgen, da der Anfangssaldo aus dem vorherigen Auszug übernommen wird.',
  'bank.archiveBlocked.deviation': 'Die Saldoabweichung muss 0,00 kr betragen, bevor der Kontoauszug archiviert werden kann.',
  'bank.archiveBlocked.lines': 'Alle Bankzeilen müssen bearbeitet sein, bevor der Kontoauszug archiviert werden kann.',
  'bank.reviewAndApprove': 'Prüfen und genehmigen',
  'bank.voucherN': 'Beleg {{n}}',
  'bank.voucherLinked': 'Beleg verknüpft',
  'bank.showVoucher': 'Beleg anzeigen',
  'bank.voucherSuggested': 'Beleg vorgeschlagen',
  'bank.voucherMissingBadge': 'Beleg fehlt',
  'bank.toast.linkRemoved': 'Die Verknüpfung wurde entfernt. Der Beleg liegt im Posteingang.',
  'bank.sendVouchersBack': 'Belege zurück in den Posteingang senden',
  'bank.toast.vouchersSentBack': 'Die Belege wurden in den Posteingang zurückgeschickt',
  'bank.analysisHint.tap': 'Lass SuperPlumma die Zeilen analysieren und Buchungen vorschlagen, oder tippe auf einen Beleg und dann auf die Bankzeile, um sie zu verknüpfen.',
  'bank.analysisHint.drag': 'Lass SuperPlumma die Zeilen analysieren und Buchungen vorschlagen, oder zieh einen Beleg direkt auf die Bankzeile, um sie zu verknüpfen.',
  'bank.showInbox': 'Posteingang anzeigen',
  'bank.toast.lineDone': 'Die Bankzeile ist gebucht und erledigt',
  'bank.toast.noInboxVouchers': 'Keine Belege im Posteingang zum Verknüpfen.',
  'bank.toast.balanceCorrected': 'Der Saldo wurde korrigiert',
  'bank.toast.misreadRemoved': 'Die falsch gelesene Zeile wurde aus dem Abgleich entfernt',
  'bank.toast.readingCorrected': 'Die Erkennung wurde korrigiert',
  'bank.toast.postedFixed': 'Die gebuchte Position wurde korrigiert',
  'bank.toast.lineRemoved': 'Die Bankzeile wurde aus dem Abgleich entfernt',
  'bank.vatTerm.jun': 'MwSt. {{year}} - 10. Juni',
  'bank.vatTerm.apr': 'MwSt. {{year}} - 10. April',
  'bank.vatTerm.feb': 'MwSt. {{year}} - 10. Februar',
  'bank.vatTerm.aug': 'MwSt. {{year}} - 31. August',
  'bank.vatTerm.oct': 'MwSt. {{year}} - 10. Oktober',
  'bank.vatTerm.dec': 'MwSt. {{year}} - 10. Dezember',
  'bank.agaTerm': 'Lohnsteuer/AGA {{n}}. Zeitraum {{year}}',
  'bank.ownerAccountFallback': 'Privat-/Inhaberkonto',
  'bank.periodHint': 'Der Kontoauszug umfasst {{from}} - {{to}}.',
  'bank.voucher': 'Beleg',
  'bank.ownerType.withdrawal': 'Privatentnahme',
  'bank.ownerType.deposit': 'Privateinlage',
  'bank.ownerType.both': 'Privatentnahme / -einlage',
  'bank.ownerType.owner': 'Inhaber / Verrechnungskonto',
  'bank.vat86.prefix': 'Der Lieferantenbetrag',
  'bank.vat86.suffix': 'ist die Grundlage. Code 86 berechnet sowohl Ausgangs- als auch Vorsteuer mit 25 %, ohne den Bankbetrag zu verringern.',
  'bank.postedWithoutVat': 'wird ohne MwSt. gebucht.',
  'bank.withVatRate': 'mit {{rate}} % MwSt.',
  'bank.amountHelp.locked': 'Der Betrag stammt aus dem Kontoauszug und kann nicht geändert werden.',
  'bank.amountHelp.unlocked': 'Die Buchung ist mit keiner Bankzeile verknüpft, daher kann der Betrag hier korrigiert werden. Die Änderung wird im Prüfpfad gespeichert.',
  'bank.amountHelp.mustMatch': 'Der Betrag muss mit der tatsächlichen Banktransaktion übereinstimmen.',
  'bank.err.enterAmount': 'Gib den Bankbetrag ein, bevor du die Zeile speicherst.',
  'bank.err.dateWithinStatement': 'Das Datum muss innerhalb des Kontoauszugs liegen: {{from}} - {{to}}.',
  'bank.err.pickTwoAccountsFree': 'Wähle zwei unterschiedliche Konten, bevor du die freie Buchung speicherst.',
  'bank.err.enterSupplierName': 'Gib den Lieferantennamen ein, bevor du die Lieferantenrechnung speicherst.',
  'bank.err.enterInvoiceNumber': 'Gib die Rechnungsnummer ein, bevor du die Lieferantenrechnung buchst.',
  'bank.err.invoicePaymentIncoming': 'Eine Rechnungszahlung muss ein Zahlungseingang auf der Bank sein.',
  'bank.err.pickInvoice': 'Wähle eine Rechnung, bevor du die Rechnungszahlung speicherst.',
  'bank.err.pickOwnerAccount': 'Wähle das Privat-/Inhaberkonto, bevor du die Buchung freigibst.',
  'bank.err.pickLoanAccount': 'Wähle ein Darlehens-/Verbindlichkeitskonto oder nutze eine freie Buchung.',
  'bank.err.loanSplitSum': 'Tilgung, Zinsen und Gebühren müssen zusammen den Bankbetrag ergeben.',
  'bank.err.supplierPaymentOutgoing': 'Die Zahlung einer Lieferantenrechnung muss ein Zahlungsausgang von der Bank sein.',
  'bank.err.pickSupplierInvoiceBeforeSave': 'Wähle eine Lieferantenrechnung, bevor du die Zahlung speicherst.',
  'bank.err.correctionReason': 'Gib kurz an, warum die Buchung korrigiert wird.',
  'bank.err.noReceiptReason': 'Gib eine kurze Begründung an, warum kein eigener Beleg nötig ist.',
  'bank.err.linkVoucherOrWaive': 'Verknüpfe einen Beleg oder kreuze an, dass keine separate Dokumentation existiert oder nötig ist.',
  'bank.err.uploadUnavailable': 'Der Beleg-Upload ist noch nicht verfügbar.',
  'bank.err.analysisFailedAfterUpload': 'Der Beleg wurde hochgeladen, aber die Analyse ist fehlgeschlagen.',
  'bank.toast.uploadedAndLinked': 'Beleg hochgeladen und mit der Bankzeile verknüpft.',
  'bank.toast.linkOnSaveCorrection': 'Der Beleg wird verknüpft, wenn du die Korrektur speicherst.',
  'bank.toast.linkOnSaveLine': 'Der Beleg wird verknüpft, wenn du die Bankzeile speicherst.',
  'bank.err.uploadFailed': 'Beleg konnte nicht hochgeladen werden.',
  'bank.modal.correctPosting': 'Buchung korrigieren',
  'bank.modal.editLine': 'Bankzeile bearbeiten',
  'bank.modal.saveCorrection': 'Korrektur speichern',
  'bank.modal.approveAndClose': 'Freigeben und schließen',
  'bank.modal.fieldsLocked': 'Bankbetrag, Datum, Typ und Bankverknüpfung sind gesperrt. Konto, MwSt. und interne Beschreibung können mit Prüfpfad korrigiert werden.',
  'bank.modal.correctionUnlocked': 'Die Buchung ist mit keiner Bankzeile im Kontoauszug verknüpft. Datum, Betrag, Konto, MwSt., Beleg und interne Beschreibung können mit Prüfpfad korrigiert werden. Ist der Buchungstyp selbst falsch, muss die Buchung storniert und neu erfasst werden.',
  'bank.modal.manualLineHelp': 'Nutze dies nur, wenn eine tatsächliche Banktransaktion im Auszug fehlt, etwa wegen eines Importfehlers oder einer Bankzeile, die vor dem Abgleich manuell erfasst werden muss.',
  'bank.help.sales': 'Verkäufe nutzen das Standard-Erlöskonto und die MwSt.-Einstellungen. Später wird dies mit Rechnung/KID verknüpft, sobald vorhanden.',
  'bank.help.ownerSole': '{{label}} wird zwischen Bank und gewähltem Privatkonto gebucht, ohne Ertrag, Aufwand oder MwSt.',
  'bank.help.ownerUnknownEntity': 'Die Rechtsform ist in den Einstellungen nicht festgelegt, daher schlägt Plumme hier kein Konto vor. Wähle das Gegenkonto selbst oder lege die Rechtsform fest, um einen Vorschlag zu erhalten.',
  'bank.help.ownerIntercompany': 'Dies ist eine Inhaber-/Verrechnungsbuchung, keine private ENK-Buchung. Wähle ein dokumentiertes Gegenkonto; Darlehen, Dividende und Kapitaleinlagen müssen im richtigen Fachablauf behandelt werden.',
  'bank.label.privateAccount': 'Privatkonto',
  'bank.label.ownerAccount': 'Inhaber-/Verrechnungskonto',
  'bank.help.shareholderTitle': 'Entnahme aus der Gesellschaft.',
  'bank.help.shareholderBody': 'Das Verrechnungskonto wird vorgeschlagen, weil es das Eigentümerverhältnis in einem Saldo bündelt. Ist dies keine Rückzahlung dessen, was die Gesellschaft dir schuldet, wird es ein Darlehen an einen Aktionär: asl. §8-7 stellt Anforderungen an Deckung und Sicherheit, und sktl. §10-11 Abs. 4 besteuert es bei dir als Dividende. Dividende und Lohn werden in ihren eigenen Abläufen gebucht.',
  'bank.help.invoicePayment': 'Nutze dies, wenn der Zahlungseingang eine bestehende Ausgangsrechnung betrifft. Gebucht wird gegen die Kundenforderung und das gewählte Bankkonto.',
  'bank.settlement.linked': 'Abrechnungsbericht verknüpft:',
  'bank.settlement.detail': 'Die Rechnung wird mit {{gross}} bezahlt, Gebühr {{fee}} und Nettozahlungseingang {{payout}}.',
  'bank.help.noInvoiceMatch': 'Ändere den Betrag oder nutze Sonstiger Verkauf, wenn der Zahlungseingang keine Rechnung betrifft.',
  'bank.help.supplierPayment': 'Nutze dies, wenn die Bankzahlung eine bereits erfasste Lieferantenrechnung betrifft. Die Zahlung wird gegen die Lieferantenverbindlichkeit und das gewählte Bankkonto gebucht.',
  'bank.pickOpenSupplierInvoice': 'Offene Lieferantenrechnung wählen',
  'bank.supplierInvoiceRemaining': '{{number}} · {{supplier}} · offen {{amount}}',
  'bank.overpayment': 'Überzahlung {{amount}}.',
  'bank.overpaymentHelp': 'Der gesamte Bankbetrag wird auf der Lieferantenrechnung erfasst, und der Überschuss bleibt als Guthaben beim Lieferanten.',
  'bank.noSupplierInvoiceFits': 'Keine offenen Lieferantenrechnungen passen zum Betrag.',
  'bank.noSupplierInvoiceFitsHelp': 'Bei einer Überzahlung muss der Restbetrag mit der Rechnung abgeglichen und der Überschuss separat gebucht werden.',
  'bank.help.taxPayment': 'Verwende dies nur für Zahlungen an Skatteetaten, die kein konkreter MwSt.-Zeitraum oder Lohnsteuerabzug/AGA sind.',
  'bank.selectedFeeAccount': 'gewähltes Gebührenkonto',
  'bank.selectedRoundingAccount': 'gewähltes Rundungskonto',
  'bank.help.roundingWarning': 'Eine Rundungsdifferenz sollte normalerweise unter 1 kr liegen. Größere Abweichungen müssen durch Prüfung von Saldo und Bankzeilen erklärt werden.',
  'bank.help.free': 'Die freie Buchung wird für Überweisungen, Verbindlichkeiten, Verrechnungen, Korrekturen oder andere Bankvorgänge verwendet, die kein normaler Einkauf, Verkauf oder keine Rechnungszahlung sind.',
  'bank.help.newSupplierInvoice': 'Verwende dies, wenn die Lieferantenrechnung noch nicht erfasst ist. Die Bankzeile wird mit Lieferantenrechnungsdetails gespeichert, damit sie später verknüpft werden kann.',
  'bank.correction.requiredHint': 'Pflichtfeld. Wird im Prüfpfad gespeichert.',
  'bank.correction.reasonPh': 'Beschreibe kurz, warum die Buchung korrigiert wird',
  'bank.noSeparateDoc.bank': 'Der Kontoauszug ist die Dokumentation – ein eigener Beleg ist nicht nötig',
  'bank.noSeparateDoc.other': 'Es gibt keine separate Dokumentation oder sie ist nicht nötig',
  'bank.shortReasonPh': 'Kurze Begründung',
  'bank.toast.pickFromInbox': 'Wähle einen Beleg aus dem Posteingang, nicht aus der Dokumentation.',
  'bank.toast.linkedOnCorrection': 'Der Beleg wird verknüpft, wenn du die Korrektur speicherst.',
  'bank.toast.linkedToLine': 'Der Beleg ist mit der Bankzeile verknüpft.',
  'bank.priv.filterAll': 'Alle',
  'bank.priv.filterOperating': 'Betrieb',
  'bank.priv.filterNew': 'Nicht bearbeitet',
  'bank.priv.filterIgnore': 'Ignorieren',
  'bank.priv.statusIgnored': 'Ignoriert',
  'bank.priv.noSafeMatches': 'Noch keine sicheren Belegtreffer zum Verknüpfen',
  'bank.priv.linkedN': '{{count}} Belege mit privaten Bankzeilen verknüpft',
  'bank.priv.pickOneLine': 'Wähle mindestens eine Bankzeile.',
  'bank.priv.ignoredN': '{{count}} Zeilen ignoriert',
  'bank.priv.movedN': '{{count}} Zeilen in den Betrieb verschoben',
  'bank.priv.intro': 'Die private Bank dient als Aufräumwerkzeug: Markiere firmenbezogene Zeilen als Betrieb und ignoriere private oder irrelevante Zeilen. Was als Betrieb markiert wird, wird auf dem Geschäftskonto gebucht.',
  'bank.priv.movedToOperating': 'In den Betrieb verschoben',
  'bank.priv.noteTap': 'Lass SuperPlumma sie automatisch verknüpfen, oder tippe auf einen Beleg und dann auf die Bankzeile.',
  'bank.priv.noteDrag': 'Lass SuperPlumma sie automatisch verknüpfen, oder zieh einen Beleg direkt auf die Bankzeile.',
  'bank.toast.lineUpdated': 'Bankzeile aktualisiert',
  'bank.err.excelParserMissing': 'Der Excel-Parser ist nicht geladen.',
  'bank.err.pdfParserMissing': 'Der PDF-Parser ist nicht geladen.',
  'bank.toast.addBankAccountFirst': 'Füge zuerst ein Bankkonto in den Einstellungen hinzu',
  'bank.err.archiveUnavailable': 'Das Archivieren von Kontoauszügen ist noch nicht verfügbar.',
  'bank.toast.privateReviewArchived': 'Die Privatprüfung ist abgeschlossen und archiviert',
  'bank.err.archiveFailed': 'Der Kontoauszug konnte nicht archiviert werden',
  'bank.err.reopenUnavailable': 'Das Wiederöffnen von Kontoauszügen ist noch nicht verfügbar.',
  'bank.toast.statementReopened': 'Der Kontoauszug wurde wieder geöffnet',
  'bank.err.reopenStatementFailed': 'Der Kontoauszug konnte nicht wieder geöffnet werden',
  'bank.account.private': 'Privatkonto',
  'bank.account.operating': 'Geschäftskonto',
  'bank.group.operating': 'Geschäftskonten',
  'bank.group.private': 'Privatkonten',
  'bank.group.doneReviews': 'Abgeschlossen geprüfte Privatauszüge',
  'bank.group.doneReconciled': 'Abgeschlossen abgestimmte Kontoauszüge',
  'bank.unknownPeriod': 'Unbekannter Zeitraum',
  'bank.handledOf': '{{handled}} von {{lines}} bearbeitet',
  'bank.page.privateTitle': 'Private Bank',
  'bank.page.title': 'Bankabstimmung',
  'bank.page.privateSubtitle': 'Räume das Privatkonto auf - markiere firmenbezogene Zeilen als Betrieb und ignoriere den Rest.',
  'bank.page.subtitle': 'Lade XLSX, CSV, PDF oder einen Screenshot von der Bank hoch, markiere Firmenzeilen als Betrieb und archiviere fertige Auszüge.',
  'bank.tab.operating': 'Betrieb',
  'bank.tab.private': 'Privat',
  'bank.tab.archive': 'Archiv',
  'bank.page.privateUploadHelp': 'Lade den Privatauszug hier nur hoch, wenn du firmenbezogene Auslagen finden willst. Er wird beim gewählten Unternehmen gespeichert, aber ohne Bankkonto aus den Einstellungen.',
  'bank.noAccountRegistered': 'Kein Bankkonto erfasst',
  'bank.stmt.reviewed': 'Geprüft',
  'bank.stmt.toReview': 'Zu prüfen',
  'bank.stmt.toReconcile': 'Abzustimmen',
  'bank.dropzone.uploadMore': 'Weitere Kontoauszüge hochladen',
  'bank.dropzone.none': 'Noch keine Kontoauszüge',
  'bank.dropzone.help': 'Zieh eine CSV-, PDF-, XLSX- oder Bilddatei von der Bank hierher, klicke zum Auswählen oder füge einen Screenshot mit Ctrl+V ein. Wir gleichen die Zeilen automatisch mit deinen Belegen ab.',
  'bank.connectHelp2': 'Rufe Transaktionen automatisch ab und lass SuperPlumma die Buchhaltung laufend buchen und abstimmen - kein manuelles Hochladen und Buchen mehr.',
  'bank.toast.openBankingInfo': 'Sichere Verbindung zur Bank über Open Banking',
  'bank.guided.step1.title': 'Auszug prüfen',
  'bank.guided.step1.sub': 'Zeitraum und Saldo prüfen',
  'bank.guided.step2.title': 'Vorschläge genehmigen',
  'bank.guided.step2.sub': 'Prüfe, was Plumme gefunden hat',
  'bank.guided.step3.title': 'Den Rest bearbeiten',
  'bank.guided.step3.sub': 'Wähle, wofür die Zahlungen sind',
  'bank.guided.step4.title': 'Belege verknüpfen',
  'bank.guided.step4.sub': 'Einkäufe dokumentieren',
  'bank.guided.step5.title': 'Abschließen',
  'bank.guided.step5.sub': 'Prüfen und archivieren',
  'bank.guided.stepOf': 'Schritt {{step}} von {{total}}',
  'bank.guided.action.matched': 'Mit bereits Gebuchtem abgeglichen',
  'bank.guided.action.fee': 'Bankgebühr',
  'bank.guided.action.invoice': 'Rechnungszahlung',
  'bank.guided.action.purchase': 'Bekannter Einkauf',
  'bank.guided.action.sale': 'Verkauf erfassen',
  'bank.guided.suggestionFromSuper': 'Vorschlag von SuperPlumma',
  'bank.guided.receivables': 'Forderungen aus Lieferungen und Leistungen',
  'bank.guided.suggestedCostAccount': 'Vorgeschlagenes Aufwandskonto',
  'bank.guided.reason.sameAmount': 'Gleicher Betrag und gleiche Zahlungsreferenz',
  'bank.guided.reason.textBased': 'Basierend auf Text, Betrag und früheren Buchungen',
  'bank.guided.suggestsAction': 'Plumme schlägt vor: {{action}}',
  'bank.guided.vatLine': '{{account}} · {{vat}} MwSt. · Betrag {{amount}}',
  'bank.guided.voucherSuffix': ' · Beleg: {{name}}',
  'bank.guided.out': 'AUS',
  'bank.guided.in': 'EIN',
  'bank.guided.moneyOut': 'GELD AUS',
  'bank.guided.moneyIn': 'GELD EIN',
  'bank.guided.unprocessedLine': '{{direction}} · Nicht bearbeitet',
  'bank.guided.bankPeriod': 'Bankzeitraum',
  'bank.guided.handledLeft': '{{handled}}/{{total}} bearbeitet · {{left}} übrig',
  'bank.guided.reopenNote': 'Wenn du die Abstimmung wieder öffnest, wird der Zeitraum zur Prüfung entsperrt. Gebuchte Zeilen müssen mit Prüfpfad korrigiert oder storniert werden, bevor sie erneut bearbeitet werden können.',
  'bank.guided.toast.enterClosing': 'Gib den Endsaldo aus dem Kontoauszug ein.',
  'bank.guided.err.checkIndividually': 'Ein oder mehrere Vorschläge müssen einzeln geprüft werden.',
  'bank.guided.toast.suggestionsDone': '{{count}} Vorschläge sind gebucht und erledigt',
  'bank.guided.err.approveSuggestions': 'Die Vorschläge konnten nicht genehmigt werden.',
  'bank.guided.toast.roundingPosted': 'Die Rundungsdifferenz von {{amount}} ist gebucht',
  'bank.guided.err.roundingFailed': 'Die Rundungsdifferenz konnte nicht gebucht werden.',
  'bank.guided.toast.markedNoVoucher': 'Der Einkauf ist als ohne Beleg markiert',
  'bank.guided.err.saveChoice': 'Die Auswahl konnte nicht gespeichert werden.',
  'bank.guided.err.voucherNotFound': 'Der Beleg wurde im Posteingang nicht gefunden.',
  'bank.guided.err.linkFailed': 'Der Beleg konnte nicht verknüpft werden.',
  'bank.guided.toast.noSafeHits': 'Keine sicheren Belegtreffer zum Verknüpfen gefunden.',
  'bank.guided.h.check': 'Stimmen Zeitraum und Saldo?',
  'bank.guided.h.rest': 'Wofür sind die restlichen Zahlungen?',
  'bank.guided.p.check': 'Prüfe, dass dies der richtige Kontoauszug ist, und gib den Saldo am Ende des Zeitraums ein.',
  'bank.guided.p.rest': 'Wähle, wofür jede Zahlung ist. Du musst keine Kontonummern kennen — Plumme hilft dir beim Buchen.',
  'bank.guided.openingHint': 'Wird normalerweise aus der letzten abgeschlossenen Abstimmung übernommen.',
  'bank.guided.closingHint': 'Den Betrag findest du auf dem Kontoauszug der Bank.',
  'bank.guided.closingMatches': 'Der Endsaldo der Bank entspricht dem von Plumme berechneten Wert.',
  'bank.guided.posting': 'Wird gebucht…',
  'bank.guided.postRounding': 'Rundungsdifferenz buchen',
  'bank.guided.smallRounding': 'Kleine Rundungsabweichung von {{amount}}',
  'bank.guided.balanceDeviates': 'Der Saldo weicht um {{amount}} ab.',
  'bank.guided.balanceDeviatesHelp': 'Bearbeite die Zahlungen in den nächsten Schritten und komm zurück, falls die Abweichung bestehen bleibt.',
  'bank.guided.canReturn': 'Du kannst später jederzeit zu diesem Schritt zurückkehren.',
  'bank.guided.correctToContinue': 'Korrigiere die Salden über das Stiftsymbol, um fortzufahren.',
  'bank.guided.checkedContinue': 'Kontoauszug ist geprüft – weiter',
  'bank.guided.superIntro': 'Einige Zeilen sind bereits gebuchten Posten zugeordnet, für andere hat SuperPlumma eine Buchung vorgeschlagen. Prüfe sie und tippe auf „Bestätigen“ — nichts wird gebucht, bevor du bestätigst.',
  'bank.guided.count.matched': 'bereits gebuchten Posten zugeordnet',
  'bank.guided.count.invoice': 'Rechnungszahlungen',
  'bank.guided.count.purchase': 'bekannte Käufe',
  'bank.guided.count.fee': 'Bankgebühren',
  'bank.guided.count.receipt': 'automatisch gefundene Belege',
  'bank.guided.fixReading': 'Auslesung aus PDF/CSV korrigieren',
  'bank.guided.suggestionsPending': '{{count}} Vorschläge sind noch nicht bestätigt. Du kannst sie jetzt bestätigen oder später zurückkommen.',
  'bank.guided.allSuggestionsDone': 'Alle Vorschläge sind bearbeitet.',
});
